var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.favoriteClass,attrs:{"disabled":_vm.isProcessing},on:{"click":function($event){return _vm.toggleFavorite()}}},[_c('common-icon',{attrs:{"name":_vm.iconName,"size":"large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }